import { Station } from '@app/core/types/stations';

export function useLowerthirdEnabled(station: Station) {
  return Boolean(
    station.featuresConfig?.videoAnalysis?.enabled &&
    station.featuresConfig?.videoAnalysis?.lowerThird?.enabled,
  );
}
